import * as dto from '@epicuro-next/data/baskets-dto';
import { addNestedObjectsToMapping } from '@epicuro-next/data/baskets-grouping';
import {
  BasketRowsGroup,
  BasketRowsGroupType,
} from 'graphql-api/baskets-api-interfaces';

import { GetRowsFn, GroupingFn, Mappings } from '../mappings';
import { simpleAttributeMapping } from '../mappings/simple-attribute.mapping';

export function groupByArticleGroup(
  items: dto.Item[],
  maps: Mappings,
  groupFn?: GroupingFn,
  getRowsFn?: GetRowsFn,
): BasketRowsGroup[] {
  const attributeName = 'articlegroup';
  const articleGroupItemIdsMap = simpleAttributeMapping(
    items,
    maps,
    attributeName,
  );

  return addNestedObjectsToMapping(
    articleGroupItemIdsMap,
    maps,
    BasketRowsGroupType.Articlegroup,
    groupFn,
    getRowsFn,
  );
}
